import { createAsyncThunk } from "@reduxjs/toolkit";
import CommonApiUrl from "./commonAPIURL";
import { DELETEAttachments, POSTAttachments, PUTAttachments } from "../../config/httpFileManagement";
import { GET } from "../../config/httpMain";
interface CommonPayload {
    ControlName: any;
    ControlValue?: any;
    ParentValue?: any;
    CompanyCode?: any;
    Type?: any;
}

export const GetListValue = createAsyncThunk('common/GetListValue', async (commonPayload: CommonPayload, thunkAPI: any) => {
    try {
        const queryString = new URLSearchParams(commonPayload as any).toString();
        const response = await GET(CommonApiUrl.GetListValue + `?${queryString}`);
        return response.data;
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error?.response?.data);
    }
});
export const GetListValueUI = createAsyncThunk('commonui/GetListValue', async (commonPayload: CommonPayload, thunkAPI: any) => {
    try {
        const queryString = new URLSearchParams(commonPayload as any).toString();
        const response = await GET(CommonApiUrl.GetListValueUI + `?${queryString}`);
        return response.data;
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error?.response?.data);
    }
});
export const UploadImage = createAsyncThunk('Images/UploadImages', async (payload: any, thunkAPI: any) => {
    try {
        const response = await POSTAttachments(CommonApiUrl.UploadImage, payload);
        return response.data;
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error?.response?.data);
    }
});
export const DeleteImageByReferenceId = createAsyncThunk('Images/DeleteImageByReferenceId', async ({ Id, ReferenceId, ImageType, BaseDirectory = "" }: any, thunkAPI: any) => {
    try {
        const queryString = new URLSearchParams({ Id, ReferenceId, ImageType, BaseDirectory }).toString();
        const response = await DELETEAttachments(CommonApiUrl.DeleteImageById + `?${queryString}`);
        return response.data;
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error?.response?.data);
    }
});
export const UpdateImageByReferenceId = createAsyncThunk('Images/UpdateImageByReferenceId', async (payload: any, thunkAPI: any) => {
    try {
        const response = await PUTAttachments(CommonApiUrl.UpdateImageById, payload);
        return response.data;
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error?.response?.data);
    }
});